import { Dimensions, Platform, StyleSheet } from 'react-native'
import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  mainText: {
    fontSize: 25,
    lineHeight: 31,
    marginTop: 17,
    marginHorizontal: 16,
    fontFamily: Fonts.type.VodafoneLt,
  },
  subText: {
    fontSize: 14.6,
    lineHeight: 18.7,
    marginTop: 16.6,
    marginBottom: 33.3,
  },

  // Confirmation
  priceContainer: {
    margin: 16,
  },
  note: {
    margin: 16,
    marginTop: 0,
  },
  secondaryButton: {
    marginHorizontal: 16,
    marginBottom: 32,
  },
  primaryButton: {
    margin: 16,
  },

  // loan
  descLoan: {
    margin: 16,
  },

  // Loader
  loaderContainer: {
    paddingTop: 64,
    paddingBottom: 120,
    alignItems: 'center',
  },
  loader: {
    width: 150,
    height: 150,
  },

  // Success
  success: {
    marginTop: 128,
    marginBottom: 32,
    alignSelf: 'center',
  },
  successTitle: {
    marginHorizontal: 16,
    marginBottom: 16,
  },
  successDesc: {
    marginHorizontal: 16,
  },
  successButton: {
    marginHorizontal: 16,
    marginTop: 114,
    marginBottom: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 32,
  },

  // Override
  productDeleteItems: {
    margin: 16,
  },
  productDeleteItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: 8,
  },
  productDeleteName: {
    flexShrink: 1,
    marginLeft: 8,
  },

  // Error
  icon: {
    alignSelf: 'center',
    marginTop: 24,
    marginBottom: 16,
  },
  title: {
    marginHorizontal: 16,
  },
  description: {
    margin: 16,
    marginBottom: 32,
  },
})
